import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FeaturedContractors = () => {
  const contractors = [
    { name: 'Jan de Vries', specialty: 'Zonnepanelen specialist', rating: 4.9, completedJobs: 156, location: 'Amsterdam', verified: true, skills: ['Zonnepanelen', 'Omvormers', 'Monitoring'] },
    { name: 'Sophie Bakker', specialty: 'Warmtepomp monteur', rating: 4.8, completedJobs: 142, location: 'Rotterdam', verified: true, skills: ['Lucht-water', 'Bodem', 'Hybride'] },
    { name: 'Mark Jansen', specialty: 'Batterijsysteem technicus', rating: 5.0, completedJobs: 203, location: 'Utrecht', verified: true, skills: ['Opslag', 'Integratie', 'Monitoring'] },
    { name: 'Lisa van Dam', specialty: 'Onderhoudsmonteur', rating: 4.9, completedJobs: 178, location: 'Den Haag', verified: true, skills: ['Preventief', 'Correctief', 'Inspectie'] }
  ];

  return (
    <section id="contractors" className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-64 rounded-full blur-[120px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          className="mb-14"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <motion.p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4" style={{ color: '#00E5A0' }}>
            — Vakmensen
          </motion.p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            Top vakmensen op het platform
          </h2>
          <p className="text-base max-w-xl" style={{ color: '#888888' }}>
            Ontmoet enkele van onze best beoordeelde specialisten
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px mb-px" style={{ background: '#1A1A1A' }}>
          {contractors?.map((contractor, index) => (
            <motion.div
              key={index}
              className="p-6 group"
              style={{ background: '#0A0A0A' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ background: '#0F0F0F' }}
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: '#1A1A1A' }}>
                  <Icon name="User" size={22} color="#00E5A0" />
                </div>
                {contractor?.verified && (
                  <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: '#00E5A0' }}>
                    <Icon name="Check" size={11} color="#0A0A0A" />
                  </div>
                )}
              </div>
              <h3 className="font-heading font-semibold text-base text-white mb-1">{contractor?.name}</h3>
              <p className="text-xs mb-4" style={{ color: '#666666' }}>{contractor?.specialty}</p>
              <div className="flex items-center gap-4 mb-4 pb-4" style={{ borderBottom: '1px solid #1A1A1A' }}>
                <div className="flex items-center gap-1">
                  <Icon name="Star" size={13} color="#00E5A0" />
                  <span className="text-sm font-body font-semibold text-white">{contractor?.rating}</span>
                </div>
                <div className="flex items-center gap-1 text-xs" style={{ color: '#666666' }}>
                  <Icon name="Briefcase" size={13} color="#666666" />
                  <span>{contractor?.completedJobs}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 mb-4">
                <Icon name="MapPin" size={13} color="#555555" />
                <span className="text-xs" style={{ color: '#666666' }}>{contractor?.location}</span>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {contractor?.skills?.map((skill, idx) => (
                  <span key={idx} className="text-xs px-2 py-0.5 rounded-sm font-body" style={{ background: '#1A1A1A', color: '#888888' }}>
                    {skill}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Recent projects */}
        <motion.div
          className="p-8"
          style={{ background: '#0D0D0D', border: '1px solid #1A1A1A' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-heading font-semibold text-white">Recent voltooide projecten</h3>
            <Link to="/login" className="text-xs font-body font-medium transition-colors hover:text-white" style={{ color: '#00E5A0' }}>
              Bekijk alle →
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: '#1A1A1A' }}>
            {[
              { title: 'Zonnepanelen project woonwijk', type: 'Zonnepanelen', location: 'Amsterdam Noord', budget: '€18.000', contractor: 'Jan de Vries' },
              { title: 'Warmtepomp nieuwbouw', type: 'Warmtepomp installatie', location: 'Rotterdam Zuid', budget: '€22.500', contractor: 'Sophie Bakker' },
              { title: 'Thuisbatterij met zonnepanelen', type: 'Thuisbatterij systeem', location: 'Utrecht Oost', budget: '€15.000', contractor: 'Mark Jansen' }
            ]?.map((project, i) => (
              <div key={i} className="p-6" style={{ background: '#0D0D0D' }}>
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs px-2 py-0.5 rounded-sm font-body" style={{ background: 'rgba(0,229,160,0.1)', color: '#00E5A0' }}>Voltooid</span>
                </div>
                <h4 className="text-sm font-body font-semibold text-white mb-2">{project?.title}</h4>
                <p className="text-xs mb-3" style={{ color: '#666666' }}>{project?.type}</p>
                <div className="flex items-center justify-between text-xs" style={{ color: '#555555' }}>
                  <span>{project?.location}</span>
                  <span className="font-semibold" style={{ color: '#00E5A0' }}>{project?.budget}</span>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedContractors;